<script setup>
import { onMounted, onBeforeUnmount } from 'vue'
import AppSetup from './modules/AppSetup.vue'
import ErrorMessageSnackbar from 'Common/components/elements/feedback/ErrorMessageSnackbar.vue'
import { RouterView } from 'vue-router'
import { useErrorStore } from 'Store/errors/errorStore'
import { useKeyboardStore } from 'Store/keyboardStore'
const errorStore = useErrorStore()
const keyboardStore = useKeyboardStore()

// Handler to update the store when Ctrl is pressed
function handleKeyDown(event) {
  if (event.ctrlKey) {
    keyboardStore.setCtrlPressed(true)
  }
}

// Handler to update the store when Ctrl is released
function handleKeyUp(event) {
  if (!event.ctrlKey) {
    keyboardStore.setCtrlPressed(false)
  }
}

// Add event listeners on mount
onMounted(() => {
  window.addEventListener('keydown', handleKeyDown)
  window.addEventListener('keyup', handleKeyUp)
})

// Remove event listeners on unmount
onBeforeUnmount(() => {
  window.removeEventListener('keydown', handleKeyDown)
  window.removeEventListener('keyup', handleKeyUp)
})
</script>

<template>
  <AppSetup>
    <ErrorMessageSnackbar :errors="errorStore.errors" />
    <router-view />
  </AppSetup>
</template>
